import adrianaPic from "@/public/images/artists/adriana.png";
import { Artist } from "@/types/types";

export const adriana = {
  id: "22",
  name: "Adriana",
  image: adrianaPic,
  description: `Introducing "Adriana," the EDM pop singer who's lighting up the scene. With a voice that seamlessly blends with electronic melodies, Adriana brings a captivating energy to the EDM pop genre.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fadriana-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Dance", "RnB", "Airy"],
      secondary: ["Singer"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 55,
        high: 69,
      },
    },
  },
} as const satisfies Artist;
